module.exports = __webpack_public_path__ + "static/media/prime-day.b38ab71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/prime-day.png
// module id = 2260
// module chunks = 0